import React from 'react';
import IconContainer from '../IconContainer';

const svg = (
  <svg width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M29 0.5H3.00002C1.34571 0.5 0 1.84571 0 3.50002V21.5C0 23.1543 1.34571 24.5 3.00002 24.5H29C30.6543 24.5 32 23.1543 32 21.5V3.50002C32 1.84571 30.6543 0.5 29 0.5ZM29 2.49999C29.1358 2.49999 29.2651 2.52818 29.3833 2.57741L16 14.1768L2.61667 2.57741C2.73483 2.52825 2.86409 2.49999 2.99995 2.49999H29ZM29 22.5H3.00002C2.44827 22.5 1.99999 22.0518 1.99999 21.4999V4.69042L15.3447 16.2559C15.5332 16.4189 15.7666 16.5 16 16.5C16.2334 16.5 16.4668 16.419 16.6553 16.2559L30 4.69042V21.5C29.9999 22.0518 29.5517 22.5 29 22.5Z" fill="#7D3FA8"/>
</svg>
);

export default IconContainer(svg);
